import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export default function Login() {
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);
  const { login } = useAuth();
  const navigate  = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: 'var(--bg-deep)',
      backgroundImage: `radial-gradient(ellipse at 60% 20%, rgba(139,127,255,0.06) 0%, transparent 60%)`
    }}>
      <div style={{ width: '100%', maxWidth: 380, padding: '0 20px' }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{ fontFamily: 'var(--font-mono)', fontSize: 32, fontWeight: 700, color: 'var(--text-primary)' }}>
            Sig<span style={{ color: 'var(--accent-purple)' }}>nal</span>
          </div>
          <div style={{ fontSize: 11, color: 'var(--text-dim)', fontFamily: 'var(--font-mono)',
                        letterSpacing: '3px', textTransform: 'uppercase', marginTop: 8 }}>
            Social Intelligence Platform
          </div>
        </div>

        <div className="card">
          <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 24, color: 'var(--text-primary)' }}>
            Sign In
          </h2>

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 16 }}>
              <label className="label">Email</label>
              <input
                type="email" required
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="you@company.com"
              />
            </div>
            <div style={{ marginBottom: 24 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 6 }}>
                <label className="label" style={{ marginBottom: 0 }}>Password</label>
                <Link to="/forgot-password" style={{ fontSize: 11, color: 'var(--text-dim)', textDecoration: 'none' }}>
                  Forgot password?
                </Link>
              </div>
              <input
                type="password" required
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
              />
            </div>

            {error && (
              <div style={{ marginBottom: 16, padding: '10px 14px', background: 'rgba(255,107,107,0.08)',
                            border: '1px solid rgba(255,107,107,0.2)', borderRadius: 6,
                            fontSize: 13, color: 'var(--accent-red)' }}>
                {error}
              </div>
            )}

            <button
              type="submit" className="btn btn-primary"
              style={{ width: '100%', justifyContent: 'center' }}
              disabled={loading}
            >
              {loading ? <span className="pulsing">SIGNING IN...</span> : 'Sign In →'}
            </button>
          </form>
        </div>

        <div style={{ textAlign: 'center', marginTop: 20, fontSize: 13, color: 'var(--text-dim)' }}>
          No account?{' '}
          <Link to="/signup" style={{ color: 'var(--accent-purple)' }}>Create one</Link>
        </div>

        <div style={{ textAlign: 'center', marginTop: 32, fontSize: 11, color: 'var(--text-dim)', opacity: 0.6 }}>
          <Link to="/privacy" style={{ color: 'inherit', textDecoration: 'none', marginRight: 16 }}>Privacy Policy</Link>
          <Link to="/terms"   style={{ color: 'inherit', textDecoration: 'none' }}>Terms of Service</Link>
        </div>
      </div>
    </div>
  );
}
